<!-- 
Created on April 29  2024
 网站登录
@author: xiaolong.li
  -->
<template>
  <!-- 李小龙 -->
  <div>
    <div
      style="
        height: 146px;
        background: #047bd0;
        padding: 20px;
        text-align: center;
      "
    >
      <h1 style="--bs-text-opacity: 1">
        <span style="color: #ffffff; font-size: 32px">
          {{ $t("register.注册") }}
        </span>
      </h1>
    </div>
    <div class="formCenter">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        style="flex: 1; padding-top: 20px"
      >
        <div style="height: 50px; padding: 20px; text-align: center">
          <h1 style="--bs-text-opacity: 1">
            <span style="color: black; font-weight: 300; font-size: 32px">{{
              $t("register.登录信息")
            }}</span>
          </h1>
        </div>
        <div class="registTitle">
          <div>
            <div>
              <a-form-model-item
                prop="email"
                :label="$t('register.电子邮箱')"
                style="text-align: left"
              >
                <a-input
                  v-model="form.email"
                  style="width: 338px"
                  :placeholder="$t('register.请输入您的邮箱')"
                />
              </a-form-model-item>
            </div>
          </div>

          <div style="margin-left: 15px">
            <div>
              <a-form-model-item
                prop="password"
                :label="$t('register.密码')"
                style="text-align: left"
              >
                <a-input
                  type="password"
                  v-model="form.password"
                  style="width: 338px"
                  :placeholder="$t('register.请输入密码')"
                />
              </a-form-model-item>
            </div>
          </div>

          <div style="margin-left: 15px">
            <div>
              <a-form-model-item
                prop="configPwd"
                :label="$t('register.确认密码')"
                style="text-align: left"
              >
                <a-input
                  type="password"
                  v-model="form.configPwd"
                  style="width: 338px"
                  :placeholder="$t('register.请输入确认密码')"
                />
              </a-form-model-item>
            </div>
          </div>
        </div>
        <div style="background-color: #ececec; width: 100%">
          <div style="height: 50px; padding: 20px; text-align: center">
            <h1 style="--bs-text-opacity: 1">
              <span style="color: black; font-weight: 300; font-size: 32px">{{
                $t("register.联系方式")
              }}</span>
            </h1>
          </div>
          <div class="registTitle">
            <div style="margin-left: 0px">
              <div>
                <a-form-model-item
                  prop="name"
                  :label="$t('register.姓名')"
                  style="text-align: left"
                >
                  <a-input
                    v-model="form.name"
                    style="width: 338px"
                    ref="name"
                    :placeholder="$t('register.请输入姓名')"
                  />
                </a-form-model-item>
              </div>
            </div>
            <div style="margin-left: 15px">
              <a-form-model-item
                prop="company"
                :label="$t('register.公司名称')"
                style="text-align: left"
              >
                <a-input
                  v-model="form.company"
                  style="width: 338px"
                  ref="company"
                  :placeholder="$t('register.请填写公司名称')"
                />
              </a-form-model-item>
            </div>
            <div style="margin-left: 15px">
              <div>
                <a-form-model-item
                  prop="cellphone"
                  :label="$t('register.联系电话')"
                  style="text-align: left"
                >
                  <a-input
                    v-model="form.cellphone"
                    style="width: 338px"
                    ref="cellphone"
                    :placeholder="$t('register.请填写手机号码')"
                  />
                </a-form-model-item>
              </div>
            </div>
          </div>
        </div>

        <div style="margin-left: 15px; display: none" prop="invoice">
          <div>
            <a-form-model-item
              prop="invoice"
              label="税务登记号"
              style="text-align: left"
            >
              <a-input
                v-model="form.invoice"
                ref="invoice"
                style="width: 338px"
                :placeholder="placeholderTax"
              />
            </a-form-model-item>
          </div>
        </div>

        <div style="margin-left: 15px; display: none">
          <div>
            <a-form-model-item
              prop="webPage"
              label="WEB (网页）"
              style="text-align: left"
            >
              <a-input
                v-model="form.webPage"
                style="width: 338px"
                ref="webPage"
                :placeholder="placeholderWeb"
              />
            </a-form-model-item>
          </div>
        </div>

        <div style="width: 100%">
          <div style="height: 50px; padding: 20px; text-align: center">
            <h1 style="--bs-text-opacity: 1">
              <span style="color: black; font-weight: 300; font-size: 32px">{{
                $t("register.发票地址")
              }}</span>
            </h1>
          </div>
          <div class="registTitle">
            <div style="margin-left: 0px">
              <div>
                <a-form-model-item
                  prop="number"
                  :label="$t('register.街道和门牌号码')"
                  style="text-align: left"
                >
                  <a-input
                    v-model="form.number"
                    style="width: 250px"
                    ref="number"
                    :placeholder="$t('register.请填写街道和门牌号码')"
                  />
                </a-form-model-item>
              </div>
            </div>
            <div style="margin-left: 15px">
              <div>
                <a-form-model-item
                  prop="city"
                  :label="$t('register.城市')"
                  style="text-align: left"
                >
                  <a-input
                    v-model="form.city"
                    style="width: 250px"
                    ref="city"
                    :placeholder="$t('register.请填写城市')"
                  />
                </a-form-model-item>
              </div>
            </div>

            <div style="margin-left: 15px">
              <div>
                <a-form-model-item
                  prop="postalCode"
                  :label="$t('register.邮编')"
                  style="text-align: left"
                >
                  <a-input
                    v-model="form.postalCode"
                    style="width: 250px"
                    ref="postalCode"
                    :placeholder="$t('register.请输入邮政编码')"
                  />
                </a-form-model-item>
              </div>
            </div>

            <div style="margin-left: 15px">
              <div>
                <a-form-model-item
                  prop="countryArr"
                  :label="$t('register.请选择国家')"
                  style="text-align: left"
                >
                  <a-select
                    style="width: 250px"
                    v-model="form.country"
                    :options="translatedCountryOptions"
                    :placeholder="$t('register.请选择国家')"
                  >
                  </a-select>
                </a-form-model-item>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 50px; padding: 20px; text-align: center">
          <h1 style="--bs-text-opacity: 1">
            <span style="color: black; font-weight: 300; font-size: 32px">{{
              $t("register.其他")
            }}</span>
          </h1>
        </div>
        <div style="display: flex; margin-top: 50px; justify-content: center">
          <div style="margin-left: 15px">
            <a-form-model-item prop="receiveNews">
              <a-checkbox @change="onChangeNews" ref="receiveNews">
                {{ $t("register.你想收到时事通讯吗") }}?
              </a-checkbox>
            </a-form-model-item>
          </div>

          <div style="margin-left: 15px">
            <a-form-model-item prop="reciveNewForklift">
              <a-checkbox @change="onchangeNewForklift" ref="reciveNewForklift">
                {{ $t("register.发送新购买的叉车吗") }}?
              </a-checkbox>
            </a-form-model-item>
          </div>
        </div>
        <div style="display: flex; justify-content: center">
          <a-form-model-item>
            <a-button
              icon="check"
              type="primary"
              @click="onSubmit"
              style="width: 240px"
            >
              {{ $t("register.发送注册请求") }}
            </a-button>
          </a-form-model-item>
        </div>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
function randomString() {
  var len = len || 32;
  var $chars =
    "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678"; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var pwd = "";
  for (var i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}
export default {
  components: {},
  computed: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.configPwd !== "" && this.form.configPwd !== undefined) {
          this.$refs.ruleForm.validateField("configPwd");
        }
        callback();
      }
    };
    var validateConfirmPass = (rule, value, callback) => {
      if (value === "" && value !== undefined) {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.form.password && value !== undefined) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var validataCheckEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入Email"));
      } else {
        if (this.data.filter((item) => item.email == value).length > 0) {
          callback(new Error("当前email已经注册"));
        } else {
          callback();
        }
      }
    };
    return {
      editState: "Add",
      data: [],
      receiveNew: "0",
      receiveForklift: "0",
      currentTime: "",
      visible: false,
      // placeholderLanguage: "请选择语言",
      // placeholderTax: "请填写税务登记",
      // placeholderWeb: "请填写WEB (网页）",
      // languageArr: [
      //   { label: "简体中文", value: "1" },
      //   { label: "英语", value: "2" },
      //   { label: "俄语", value: "3" },
      //   { label: "西班牙语", value: "4" },
      //   { label: "日语", value: "5" },
      // ],
      countryOptions: [
        { label: "中国", value: "1" },
        { label: "英国", value: "2" },
        { label: "俄罗斯", value: "3" },
        { label: "西班牙", value: "4" },
        { label: "日本", value: "5" },
      ],
      form: {
        email: "",
        pwd: "",
        //configPwd: "",
        //language: "",
        name: "",
        //surname: "",
        cellphone: "",
        company: "",
        invoice: "",
        // webPage: "",
        city: "",
        //country: "",
        //number: "",
        //postalCode: "",
        receiveNews: "",
        reciveNewForklift: "",
      },
      rules: {
        email: [
          { required: true, message: "请输入Email", trigger: "blur" },
          { validator: validataCheckEmail, trigger: "blur" },
        ],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          { validator: validataCheckEmail, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            max: 10,
            message: "长度在 6 到 10 个字符",
            trigger: "blur",
          },
          { validator: validatePass, trigger: "blur" },
        ],
        configPwd: [
          { required: true, message: "请输入确认密码", trigger: "blur" },
          {
            min: 6,
            max: 10,
            message: "长度在 6 到 10 个字符",
            trigger: "blur",
          },
          { validator: validateConfirmPass, trigger: "blur", required: true },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        cellphone: [{ required: true, message: "请输入电话", trigger: "blur" }],
      },
    };
  },
  computed: {
    // 使用计算属性来返回翻译后的国家选项数组
    translatedCountryOptions() {
      return this.countryOptions.map((option) => ({
        label: this.$t(`register.${option.label}`), // 假设你的翻译键是 "register.中国", "register.英国" 等
        value: option.value,
      }));
    },
  },
  mounted() {
    //获取人员记录
    this.checkEmail();
    this.editState = this.$route.query.editState;
    if (
      this.editState == "Add" &&
      Object.keys(this.$store.state.userInfo).length > 0
    ) {
      this.$router.push({ path: "/forkliftList" });
    }
    if (this.editState == "edit") {
      this.form = {
        id: this.$store.state.userInfo.id,
        name: this.$store.state.userInfo.name,
        cellphone: this.$store.state.userInfo.cellphone,
        email: this.$store.state.userInfo.email,
        company: this.$store.state.userInfo.company,
        pwd: this.$store.state.userInfo.password,
        invoice: this.$store.state.userInfo.invoice,
        city: this.$store.state.userInfo.city,
        receiveNews: this.$store.state.userInfo.receiveNews,
        reciveNewForklift: this.$store.state.userInfo.reciveNewForklift,
        createTime: moment(this.$store.state.createTime, "YYYY-MM-DD HH:mm:ss"),
      };
    }
  },
  methods: {
    onchangeNewForklift() {
      this.receiveForklift = "1";
    },
    onChangeNews() {
      this.receiveNew = "1";
    },
    setTimes() {
      let year = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let month = mm < 10 ? "0" + mm : mm;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      let hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      this.form.createTime =
        year + "-" + month + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      //this.form.createTime = "2024-01-01 00:00:00";
    },
    checkEmail() {
      if (
        this.form.email != this.$store.state.userInfo.email &&
        Object.keys(this.$store.state.userInfo).length > 0
      ) {
        return null;
      }

      var _this = this;
      axios
        .post(this.$apiUrl + "/api/general/queryMulti", {
          tableName: "jf_web_user",
          offset: 0,
          limit: 10,
        })
        .then((res) => {
          _this.data = res.data.data;
        });
    },
    addUser() {
      if (this.editState == "Add") {
        this.setTimes();
      }
      var records = {
        ...this.form,
        id: this.editState == "Add" ? randomString() : this.form.id,
        name: this.form.name,
        cellphone: this.form.cellphone,
        email: this.form.email,
        password: this.form.password,
        company: this.form.company,
        industry: "",
        province: "",
        city: this.form.city,
        invoice: this.form.invoice,
        receiveNews: this.receiveNew,
        reciveNewForklift: this.receiveForklift,
        createTime: this.form.createTime,
        // classKeywordslabel: this.classKeywordsArr
        //   .filter((item) => this.form.classKeywords.indexOf(item.value) > -1)
        //   .map((item) => item.label)
        //   .join(","),
      };
      let record = {
        id: records.id,
        name: records.name,
        cellphone: records.cellphone,
        email: records.email,
        password: records.password,
        company: records.company,
        industry: "",
        province: "",
        city: records.city,
        invoice: records.invoice,
        receiveNews: records.receiveNews,
        reciveNewForklift: records.reciveNewForklift,
        createTime: records.createTime, //moment(records.createTime, "YYYY-MM-DD HH:mm:ss"),
      };
      axios({
        url:
          this.editState == "Add"
            ? this.$apiUrl + "/api/addRecord"
            : this.$apiUrl + "/api/general/updateSingle",
        method: "POST",
        data: { tableName: "jf_web_user", record },
        logRequired: false, // false为不存入日志
      }).then((res) => {
        if (this.editState == "Add") {
          if (res.data.errCode != "0") {
            this.$notification.error({
              message: "注册失败",
              description: "网络请求错误!",
            });
            return;
          }
          this.$notification.success({
            message: "操作成功",
            description: "注册成功!",
          });
          this.login();
        } else {
          if (res.data.errCode != "0") {
            this.$notification.error({
              message: "注册失败",
              description: "网络请求错误!",
            });
            return;
          }
          this.$notification.success({
            message: "操作成功",
            description: "修改成功!",
          });
          this.$store.dispatch("setMessage", []);
          localStorage.setItem("userJson", {});
          this.$store.dispatch("setMessage", record);
          localStorage.setItem("userJson", JSON.stringify(record));
          this.login();
        }
      });
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.addUser();
        }
      });
    },
    login() {
      this.$router.push({ path: "/Login" });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    show() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
    },
  },
};
</script>

<style scoped>
.formCenter {
  border: solid 1px black;
  display: flex; /* 使用Flex布局 */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
}
.registTitle {
  display: flex;
  margin-top: 50px;
  justify-content: center;
  text-align: center;
}
</style>
